import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { DatasourceStore } from '@y42/datasource';
import { Y42FeatureType } from '@y42/json-schema';
import { SqlModelingGitFactoryService } from './sql-modeling-git-factory.service';
import { SqlModelingState } from './sql-modeling.model';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'sql-modeling', idKey: '$path' })
export class SqlModelingStore extends DatasourceStore<SqlModelingState> {
  constructor(protected readonly gitFactory: SqlModelingGitFactoryService) {
    super(Y42FeatureType.SqlModel, gitFactory);
  }
}
